module.exports = __webpack_public_path__ + "img/mergdata_mob_2.ff71fd85.png";